import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, IconButton, InputGroup, InputRightAddon } from '@chakra-ui/react';
import { memo, useEffect, useState } from 'react';
import { Svg } from '../../base';
import { InputNumber } from '../InputNumber';
const NumberStepperFC = ({ isReadonly, value, max, min = 0, onChange }) => {
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    const increment = () => {
        const newValue = currentValue + 1;
        if (max && newValue > max) {
            return;
        }
        setCurrentValue(newValue);
        onChange(newValue);
    };
    const decrement = () => {
        const newValue = currentValue - 1;
        if (newValue < min) {
            return;
        }
        setCurrentValue(newValue);
        onChange(newValue);
    };
    return (_jsxs(InputGroup, { size: "xs", children: [_jsx(InputNumber, { min: min, max: max, size: "xs", variant: "outline", isOnChangeOnlyOnBlur: true, disabled: true, value: currentValue }), _jsx(InputRightAddon, { bg: "darkWhite", children: _jsxs(Flex, { gap: "8px", children: [_jsx(IconButton, { size: "2sm", "aria-label": "", variant: "transparent", isDisabled: isReadonly, icon: _jsx(Svg, { size: "s12", name: "Minus" }), onClick: () => decrement() }), _jsx(IconButton, { size: "2sm", "aria-label": "", isDisabled: isReadonly, variant: "transparent", icon: _jsx(Svg, { size: "s12", name: "Plus" }), onClick: () => increment() })] }) })] }));
};
export const NumberStepper = memo(NumberStepperFC);
//# sourceMappingURL=NumberStepper.js.map